import { Link } from "react-router-dom";
import { Compass, Bus, ClipboardCheck, Users, Bell } from "lucide-react";

const STEPS = [
  { title: "Explore the World",      body: "Discover top destinations, hidden gems, and local experiences from around the globe.", Icon: Compass,        hue: "bg-sky-50 text-sky-700" },
  { title: "Seamless Transport",     body: "Find and compare flights, trains, buses, ferries, and car rentals in one place.",     Icon: Bus,            hue: "bg-emerald-50 text-emerald-700" },
  { title: "Plan & Organize Trips",  body: "Plan itineraries, manage bookings, track expenses and keep every detail organized.",   Icon: ClipboardCheck, hue: "bg-amber-50 text-amber-700" },
  { title: "Connect with Travelers", body: "Join communities, ask questions, share tips, and connect with travelers worldwide.",   Icon: Users,          hue: "bg-fuchsia-50 text-fuchsia-700" },
  { title: "Travel Smarter Every Day", body: "Get real-time alerts, deals, recommendations and updates that keep you ahead.",       Icon: Bell,           hue: "bg-violet-50 text-violet-700" },
];

export default function OnboardingStrip() {
  return (
    <section className="rounded-3xl bg-white border border-slate-200 p-5 sm:p-7 shadow-sm" data-testid="home-onboarding-strip">
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.24em] text-emerald-700">Welcome to Traveler Pulse™</div>
          <h2 className="font-serif font-800 text-2xl sm:text-3xl text-blue-900 tracking-tight mt-1">Get started in 5 steps</h2>
        </div>
        <Link to="/msp" data-testid="home-onboarding-cta" className="hidden sm:inline-block text-blue-700 font-700 hover:underline text-sm">Explore App →</Link>
      </div>
      <div className="flex gap-3 overflow-x-auto snap-x snap-mandatory pb-2 scrollbar-none" style={{ scrollbarWidth: "none" }}>
        {STEPS.map((s, idx) => (
          <div key={s.title} data-testid={`home-onboarding-step-${idx + 1}`}
            className="snap-start shrink-0 w-[240px] sm:w-[260px] rounded-2xl bg-white border border-slate-200 p-4">
            <div className={`w-10 h-10 rounded-xl grid place-items-center ${s.hue}`}><s.Icon className="w-5 h-5" /></div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-400 mt-3">Step {idx + 1}</div>
            <div className="font-serif font-800 text-base text-blue-900 leading-tight mt-1">{s.title}</div>
            <div className="text-xs text-slate-600 mt-1.5 leading-relaxed">{s.body}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
